import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Form, Table, Radio } from "semantic-ui-react";

import TimecodeInput from "./TimecodeInput";
import {
  set_first_timeCode_index,
  setOrgTimeString,
} from "../../../actions/editTableActions";
import { activeTimecodeshift } from "../../../actions/transOperationActions";
import TimeUtils from "../../../helper/TimeUtils";

class TimecodeShiftMainView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Sign: "+",

      newTimeCode: "", //要調整的

      differanceTimeCode: "", //中間的

      timeshift: this.props.timeshift,

      showFirstIndex: 1,
      showLastIndex: 1,
      firstDataIndex: 0,
      lastDataIndex: 0,
      selectIndex: 0, //選定的
      editTable: this.props.editTable, //選定的

      firstData: {},
      lastData: {},
    };

    this.send_setOrgTimeString = this.send_setOrgTimeString.bind(this);
  }

  componentWillUnmount() {}

  //更新對比
  send_setOrgTimeString() {
    const { data } = this.props.editTable;
    let orgData = data[this.props.timeshift.firstDataIndex];
    this.props.setOrgTimeString(orgData["In"]);
  }

  async componentDidMount() {
    try {
      const { data } = this.props.editTable;

      if (data !== null) {
        this.setState({
          editTable: this.props.editTable,
          firstDataIndex: this.props.timeshift.firstDataIndex,
          lastDataIndex: data.length - 1,
          showFirstIndex: this.props.timeshift.firstDataIndex + 1,
          showLastIndex: data.length,
        });

        this.send_setOrgTimeString();
      }
    } catch (err) {
      console.log(`componentDidMount ${err}`);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)

    const { data } = nextProps.editTable;

    if (data !== null) {
      this.setState({
        editTable: nextProps.editTable,
        firstDataIndex: nextProps.timeshift.firstDataIndex,
      });
    }
  }

  render() {
    const { firstDataIndex, lastDataIndex, showFirstIndex, showLastIndex } =
      this.state;
    const { selectIndex, editTable } = this.state;
    const { data } = editTable;

    //按鈕切換
    const arrayTitle = ["Shift To New Timecode", " Shift By Difference"];
    let buttonArrayView = arrayTitle.map((title, index) => {
      if (parseFloat(index) === parseFloat(selectIndex)) {
        return (
          <Button
            color="blue"
            size="tiny"
            onClick={() => {
              this.setState({ selectIndex: index });
            }}
          >
            {title}
          </Button>
        );
      } else {
        return (
          <Button
            basic
            size="tiny"
            onClick={() => {
              this.setState({ selectIndex: index });
            }}
          >
            {title}
          </Button>
        );
      }
    });

    let mainView;
    if (data !== null) {
      mainView = (
        <div
          id="TimecodeMainView"
          className="p-5  w-100"
          style={{ zIndex: "200" }}
        >
          <hr />
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell> </Table.HeaderCell>
                <Table.HeaderCell>Line No.</Table.HeaderCell>
                <Table.HeaderCell>Original Timecode</Table.HeaderCell>
                <Table.HeaderCell size="mini"> </Table.HeaderCell>
                <Table.HeaderCell>Difference</Table.HeaderCell>
                <Table.HeaderCell> </Table.HeaderCell>
                <Table.HeaderCell>New Timecode</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>From</Table.Cell>

                <Table.Cell>
                  <input
                    style={{ width: "50px" }}
                    value={showFirstIndex}
                    onChange={(event) => {
                      this.setState({ showFirstIndex: event.target.value });

                      if (parseFloat(event.target.value) >= 0) {
                        this.setState({
                          firstDataIndex: parseFloat(event.target.value) - 1,
                        });

                        //設定舊時間
                        this.props.set_first_timeCode_index(
                          parseFloat(event.target.value) - 1
                        );

                        //設定舊時間的字串
                        let stringIndex = parseFloat(event.target.value) - 1;
                        let orgData = data[stringIndex];
                        this.props.setOrgTimeString(orgData["In"]);
                      }
                    }}
                  />
                </Table.Cell>

                <Table.Cell>
                  <TimecodeInput
                    selectIndex={selectIndex}
                    orgData={data[firstDataIndex]}
                    type={"firstOrgTime"}
                  />
                </Table.Cell>

                <Table.Cell></Table.Cell>

                <Table.Cell rowSpan="2">
                  <div>
                    <Form>
                      <Form.Field>
                        Selected value: <b>{this.state.value}</b>
                      </Form.Field>
                      <Form.Field>
                        <Radio
                          label="+"
                          name="radioGroup"
                          value="+"
                          checked={this.state.Sign === "+"}
                          onChange={(e) => {
                            this.setState({ Sign: "+" });
                          }}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Radio
                          label="-"
                          name="radioGroup"
                          value="-"
                          checked={this.state.Sign === "-"}
                          onChange={(e) => {
                            this.setState({ Sign: "-" });
                          }}
                        />
                      </Form.Field>
                    </Form>

                    <TimecodeInput
                      selectIndex={selectIndex}
                      orgData={data[firstDataIndex]}
                      type={"differenceTime"}
                    />
                  </div>
                </Table.Cell>

                <Table.Cell></Table.Cell>

                <Table.Cell>
                  <TimecodeInput
                    selectIndex={selectIndex}
                    orgData={data[firstDataIndex]}
                    type={"firstNewTime"}
                  />
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell>To</Table.Cell>

                <Table.Cell>
                  <input
                    style={{ width: "50px" }}
                    value={showLastIndex}
                    onChange={(event) => {
                      this.setState({ showLastIndex: event.target.value });

                      if (parseFloat(event.target.value) >= 0) {
                        this.setState({
                          lastDataIndex: parseFloat(event.target.value) - 1,
                        });
                      }
                    }}
                  />
                </Table.Cell>

                <Table.Cell>
                  <TimecodeInput
                    selectIndex={selectIndex}
                    orgData={data[lastDataIndex]}
                    type={"secondOrgTime"}
                  />
                </Table.Cell>

                <Table.Cell></Table.Cell>

                <Table.Cell></Table.Cell>

                <Table.Cell>
                  <TimecodeInput
                    selectIndex={selectIndex}
                    orgData={data[lastDataIndex]}
                    type={"secondNewTime"}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          <Button
            basic
            size="tiny"
            className="float-right"
            onClick={async () => {
              const { orgTimeString, newTitleString } = this.props.timeshift; 
              this.props.applyshift(
                selectIndex,
                firstDataIndex,
                lastDataIndex,
                orgTimeString,
                newTitleString,
                this.state.Sign
              ); 
            }}
          >
            Apply
          </Button>
        </div>
      );
    } 

    return (
      <div>
        {buttonArrayView}
        {mainView}
      </div>
    );
  }
}

TimecodeShiftMainView.propTypes = {};

const mapStateToProps = (state) => ({
  editTable: state.editTable,
  timeshift: state.timeshift,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {
  set_first_timeCode_index,
  setOrgTimeString,
  activeTimecodeshift,
})(withRouter(TimecodeShiftMainView));



// WEBPACK FOOTER //
// ./src/components/layout/TimecodeShift/TimecodeShiftMainView.js